import apiClient from 'utilities/apiClient';

export const freecontainers = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.freeContainers}/${url}`,
    payload,
    true
  );
};
export const updatebin = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.freeContainers}/${url}`,
    payload,
    true
  );
};
export const getcontainerbyid = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.freeContainers}/${url}`,
    payload,
    true
  );
};

export const bin_positions = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.freeContainers}/${url}`,
    payload,
    true
  );
};

export const getBatch = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.batch}/${url}`, payload, true);
};

export const getEquipments = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.bomProdUser}/${url}`, payload, true);
};

export const updateEqp = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.bomProdUser}/${url}`, payload, true);
};

export const updateArea = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.AreasList}/${url}`, payload, true);
};

export const area_positions = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.AreasList}/${url}`, payload, true);
};

export const getProdBinContainers = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.productDetails}/${url}`,
    payload,
    true
  );
};
